module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_M1-074e3cb44d7c207a6fb79e0445eeece7.png";